export default __webpack_public_path__ + "static/media/www.88ab63ac.png";